import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, renderList as _renderList, unref as _unref, toDisplayString as _toDisplayString, createBlock as _createBlock, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, createSlots as _createSlots } from "vue"

const _hoisted_1 = { class: "dialog-content pt-6" }
const _hoisted_2 = {
  key: 0,
  class: "loading-container"
}
const _hoisted_3 = {
  key: 0,
  class: "supervisor__change-stage mb-6"
}
const _hoisted_4 = { class: "content" }
const _hoisted_5 = {
  key: 0,
  class: "mb-2"
}
const _hoisted_6 = {
  class: "checkbox-group pt-2",
  style: {"pointer-events":"none","max-width":"650px"}
}
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "checkbox-group__label mt-2" }, "Количественные цели этапа", -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "checkbox-group__label mt-4" }, "Качественные цели этапа", -1)
const _hoisted_9 = {
  key: 1,
  class: "row"
}
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "mark" }, "Текущая", -1)
const _hoisted_11 = {
  key: 0,
  class: "mt-2 mb-1"
}
const _hoisted_12 = {
  key: 2,
  class: "checkbox-group"
}
const _hoisted_13 = { class: "checkbox-group__label" }
const _hoisted_14 = {
  key: 2,
  class: "dialog-content pb-6"
}

import { computed, nextTick, onMounted, reactive, ref, watch } from 'vue';
import { useDialogStore } from '@/stores/dialogs';
import { formApi } from '@/api/form';
import VDialogHeader from './VDialogHeader.vue';
import VStepper from '../VStepper.vue';
import { useErrors } from '@/utils/use-errors';
import { useProgramsStore } from '@/stores/programs';
import { useAccountStore } from '@/stores/account';
import { useTrackersStore } from '@/stores/trackers';
import VFullRadioGroup from '../VFullRadioGroup.vue';
import VUserInfo from '../VUserInfo.vue';
import VCollapse from '../VCollapse.vue';
import SuccesDialog from './SuccesDialog.vue';
import { useSupervisorStore } from '@/stores/supervisor';
import VLimitTag from '../VLimitTag.vue';

type Column = { id: string, name: string, type: string, choises?: { [key: string]: string }, row?: boolean, info?: { [key: string]: string } }

export default /*#__PURE__*/_defineComponent({
  __name: 'CreateSupervisorReportDialog',
  props: {
    report: null
  },
  setup(__props: any) {

const props = __props as { report?: any }



const items = reactive<{ name: string, columns: Column[] }[]>([])

const status = ref("init")

const dialogStore = useDialogStore()
const step = ref(1)
const stepBack = () => {
  if (step.value === 1) {
    dialogStore.close()
    return
  }
  step.value--
}

onMounted(() => {
  programsStore.requestChecklist()
})

const values = reactive<{ [key: string]: any }>({})

let initialFields: any = {}
let multiselectFields: string[] = []

onMounted(async () => {
  const formData = await formApi.getFormData("shrt2izhN8aIgzLWJ")
  status.value = "loaded"
  status.value = "loaded"
  const keys = new Set()
  let page: typeof items[0] = { name: "", columns: [] }

  for (let data of formData.columns) {
    const name = data.metadata?.title || data.name
    const type = data.type
    const id = data.name
    const column: Column = { id, name, type  }
    keys.add(id)

    const tags = (data.metadata?.description || "")
    if (tags) {
      const newPage = tags.match(/new-page "(.+?)"/)
      if (newPage) {
        page = { name: newPage[1], columns: [] }
        items.push(page)
      } 
      if (tags.includes("/yes-no-button")) {
        column.type = "yes-no-button"
      }
      if (tags.includes("/row")) {
        column.row = true
      }
    }
    if (id === "Оценка за цель команды") {
      column.info = {
        "3": "Нет цели на программу",
        "4": "Есть цель на программу, не прозрачны количественные и качественные метрики, не синхронизирована цель на программу с текущей ситуацией команды",
        "5": `Ясная и понятная цель, есть количественные и качественные показатели, текущая ситуация команды и цели синхронизированы`
      }
    }
    if (id === "Оценка понимания трекером ключевого ограничения") {
      column.info = {
        "3": "Трекер не понимает",
        "4": "Трекер понимает частично",
        "5": "Трекер понимает правильно"
      }
    }
    if (id === "Есть ли у трекера стратегия работы с командой?") {
      column.info = {
        "3": "Нет",
        "4": "Частично присутствует",
        "5": "Есть четкое видение стратегии работы с командой"
      }
    }
    if (id === "Совпадает ли стратегия трекера с ключевым ограничением?") {
      column.info = {
        "3": "Цель спринта не доcтигнута. Совсем не делали что планировали",
        "4": "Делали что планировали, но не достигли целей спринта",
        "5": "Достигли целей спринта"
      }
    }
    if (data.typeOptions?.choices) {
      let arr = data.typeOptions.choiceOrder.map((id: string) => [ id, data.typeOptions.choices[id].name ] )
      const initialValue = arr.find((item: any) => item[1] === "1")
      if (initialValue) {
        initialFields[id] = initialValue[0]
        arr = arr.filter((item: any) => item[1] !== "1" && item[1] !== "2" )
      }
      column.choises = Object.fromEntries(arr)
    }
    if (type === 'foreignKey') {
      multiselectFields.push(id)
    }
    page.columns.push(column)
    
    if (type === "multiSelect") {
      values[column.id] = []
    }
  }

  if (props.report) {
    values['Программа'] = props.report.programId
    await nextTick()
    values['Трекер'] = props.report.trackerId
    await nextTick()
    values['Команда'] = props.report.teamId
    await nextTick()
    for (let [key, value] of Object.entries(props.report.fields)) {
      if (!keys.has(key)) continue
      values[key] = value
    }

    for (let item of items) {
      for (let column of item.columns) {
        if (column.choises && column.id in values) {
          values[column.id] = Object.entries(column.choises).find(i => i[1] === values[column.id])![0]
        }
      }
    }
  }
})

const programsStore = useProgramsStore()
const accountStore = useAccountStore()

const teams = ref()
watch(() => values["Программа"], (programId) => {
  if (!programId) return
  const program = programsStore.programs.find(item => item.id === programId)
  teams.value = program?.teams || []
  if (!accountStore.isDirector) {
    teams.value = teams.value.filter((team: any) => team.supervisorId == accountStore.currentUser!.id)
  }
  if (values["Команда"] && !teams.value.find((item: any) => item.id === values["Команда"])) {
    delete values["Команда"]
  }
  if (values["Трекер"] && !getSelectItems("Трекер").find((tracker: any) => tracker.id === values["Трекер"])) {
    delete values["Трекер"]
  }
})
const team = computed(() => {
  const program = programsStore.programs.find(item => item.id === values["Программа"])
  if (!program) return null
  const team = program.teams.find(team => team.id === values["Команда"])
  return team || null
})
watch(() => team.value, () => {
  values["Трекер"] = team.value?.trackerId
})

const trackersStore = useTrackersStore()
const getSelectItems = (name: string) => {
  if (name === "Программа") {
    return programsStore.programs
  }
  if (name === "Команда" || name === "Название команды") {
    if (values["Трекер"]) {
      return teams.value?.filter((team: any) => team.trackerId === values["Трекер"])
    }
    return teams.value
  }
  if (name === "Трекер") {
    const arr = Object.values(trackersStore.trackers)
    if (!teams.value) return arr
    return arr.filter(tracker => !!teams.value.find((item: any) => item.trackerId === tracker.id) )
  }
  if (name === "Подтвердить точку перехода") {
    return programsStore.stages
  }
  return []
}

const lastReport = ref<any | null>()
const lastLimitReport = ref<any | null>()
const requestTeamChecklist = async () => {
  const teamId = values["Команда"]
  const resp = await formApi.getCheckList(teamId)
  lastReport.value = resp.lastReport 
  lastLimitReport.value = resp.lastLimitReport
}

const errors = useErrors(values)
const ignore = [ "Запрос на ресурсы", "Запрос на смену контрольной точки", "Новая контрольная точка" ]
const stepForward = (stepForward = true) => {
  let hasError = false

  for (let column of items[step.value-1].columns) {
    if (!values[column.id] && !ignore.includes(column.id) && !column.name.includes("опционально")) {
      errors[column.id] = "Поле обязательно к заполнению"
      hasError = true
    }
  }

  if (hasError) {
    console.log(errors)
    return false
  }
  if (stepForward) {
    step.value++
  }
  if (stepForward && step.value === 2) {
    requestTeamChecklist()
  }

  return true
}


const pending = ref(false)
const supervisorStore = useSupervisorStore()
const submit = async () => {
  if (stepForward(false) === false) return
  pending.value = true
  try {
    
    const _values = { ...values }
    for (let [ name, value ] of Object.entries(_values)) {
      if (multiselectFields.includes(name) && !Array.isArray(value)) {
        _values[name] = [ value ]
      }
    }

    if (props.report) {
      await formApi.editSupervisorForm(props.report.id, _values)
      dialogStore.open(SuccesDialog, { title: "Отчет сохранен", content: "Данные обновлены" })
    } else {
      await formApi.sendSupervisorForm(_values)
      dialogStore.open(SuccesDialog, { title: "Отчет отправлен", content: "Спасибо за проделанную работу!" })
    }
    setTimeout(() => {
      supervisorStore.requestReports()
    }, 1500)


  } catch(e) {
    pending.value = false
  }
}



return (_ctx: any,_cache: any) => {
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_checkbox = _resolveComponent("v-checkbox")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_textarea = _resolveComponent("v-textarea")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_window_item = _resolveComponent("v-window-item")!
  const _component_v_window = _resolveComponent("v-window")!
  const _component_v_btn = _resolveComponent("v-btn")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(VDialogHeader, null, {
      default: _withCtx(() => [
        (props.report)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _createTextVNode("Редактирование отчета супервайзера")
            ], 64))
          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              _createTextVNode("Создание отчета супервайзера")
            ], 64))
      ]),
      _: 1
    }),
    _createElementVNode("div", _hoisted_1, [
      _createVNode(VStepper, {
        modelValue: step.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((step).value = $event)),
        steps: items.map(item => item.name),
        class: "pb-6"
      }, null, 8, ["modelValue", "steps"])
    ]),
    (status.value === 'init')
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(_component_v_progress_circular, {
            indeterminate: "",
            color: "primary"
          })
        ]))
      : (_openBlock(), _createBlock(_component_v_window, {
          key: 1,
          modelValue: step.value,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((step).value = $event))
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(items, (page, index) => {
              return (_openBlock(), _createBlock(_component_v_window_item, {
                value: index+1,
                class: "px-6 pt-2"
              }, {
                default: _withCtx(() => [
                  (index === 2 && lastReport.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                        _createVNode(_component_v_icon, { icon: "mdi-information-outline" }),
                        _createElementVNode("div", _hoisted_4, [
                          (lastReport.value.changeStageRequest)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                                _createVNode(VUserInfo, {
                                  "only-name": "",
                                  "user-id": lastReport.value.trackerId
                                }, null, 8, ["user-id"]),
                                _createTextVNode(" запрашивает подтверждение перехода контрольной точки с "),
                                _createElementVNode("u", null, _toDisplayString(_unref(programsStore).getStage(_unref(team)!.programStageId)?.name), 1),
                                _createTextVNode(" на "),
                                _createElementVNode("u", null, _toDisplayString(_unref(programsStore).getStage(lastReport.value.newProgramStageId)?.name), 1)
                              ]))
                            : _createCommentVNode("", true),
                          _createElementVNode("div", null, [
                            _createVNode(VCollapse, { title: "Чек-лист" }, {
                              default: _withCtx(() => [
                                _createElementVNode("div", _hoisted_6, [
                                  _hoisted_7,
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(programsStore).checklists[lastReport.value.programStageId]?.quantity, (item) => {
                                    return (_openBlock(), _createBlock(_component_v_checkbox, {
                                      "model-value": !!lastReport.value.stageTasks.find((_task) => _task.id === item.id),
                                      label: item.title,
                                      "hide-details": ""
                                    }, null, 8, ["model-value", "label"]))
                                  }), 256)),
                                  _hoisted_8,
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(programsStore).checklists[lastReport.value.programStageId]?.quality, (item) => {
                                    return (_openBlock(), _createBlock(_component_v_checkbox, {
                                      "model-value": !!lastReport.value.stageTasks.find((_task) => _task.id === item.id),
                                      label: item.title,
                                      "hide-details": ""
                                    }, null, 8, ["model-value", "label"]))
                                  }), 256))
                                ])
                              ]),
                              _: 1
                            })
                          ])
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (!!page.columns.find(item => item.row))
                    ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(page.columns.filter(item => item.row), (column) => {
                          return (_openBlock(), _createBlock(_component_v_select, {
                            modelValue: values[column.id],
                            "onUpdate:modelValue": ($event: any) => ((values[column.id]) = $event),
                            "error-messages": _unref(errors)[column.id],
                            items: getSelectItems(column.name),
                            label: column.name,
                            "item-title": "name",
                            "item-value": "id",
                            variant: "outlined"
                          }, null, 8, ["modelValue", "onUpdate:modelValue", "error-messages", "items", "label"]))
                        }), 256))
                      ]))
                    : _createCommentVNode("", true),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(page.columns.filter(item => !item.row), (column) => {
                    return (_openBlock(), _createElementBlock("div", null, [
                      (column.type === 'foreignKey')
                        ? (_openBlock(), _createBlock(_component_v_select, {
                            key: 0,
                            modelValue: values[column.id],
                            "onUpdate:modelValue": ($event: any) => ((values[column.id]) = $event),
                            "error-messages": _unref(errors)[column.id],
                            items: getSelectItems(column.name),
                            label: column.name,
                            "item-title": "name",
                            "item-value": "id",
                            variant: "outlined"
                          }, _createSlots({ _: 2 }, [
                            (column.id === 'Новая контрольная точка')
                              ? {
                                  name: "item",
                                  fn: _withCtx(({ props }) => [
                                    _createVNode(_component_v_list_item, _normalizeProps(_guardReactiveProps(props)), _createSlots({ _: 2 }, [
                                      (_unref(team)?.programStageId === props.value)
                                        ? {
                                            name: "append",
                                            fn: _withCtx(() => [
                                              _hoisted_10
                                            ]),
                                            key: "0"
                                          }
                                        : undefined
                                    ]), 1040)
                                  ]),
                                  key: "0"
                                }
                              : undefined
                          ]), 1032, ["modelValue", "onUpdate:modelValue", "error-messages", "items", "label"]))
                        : (column.type === 'select')
                          ? (_openBlock(), _createBlock(VFullRadioGroup, {
                              key: 1,
                              label: column.name,
                              tooltips: column.info,
                              items: column.choises!,
                              modelValue: values[column.id],
                              "onUpdate:modelValue": ($event: any) => ((values[column.id]) = $event),
                              "error-messages": _unref(errors)[column.id]
                            }, {
                              default: _withCtx(() => [
                                (column.id === 'Оценка понимания трекером ключевого ограничения')
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                                      (lastLimitReport.value)
                                        ? (_openBlock(), _createBlock(VLimitTag, {
                                            key: 0,
                                            report: lastLimitReport.value
                                          }, null, 8, ["report"]))
                                        : _createCommentVNode("", true)
                                    ]))
                                  : _createCommentVNode("", true)
                              ]),
                              _: 2
                            }, 1032, ["label", "tooltips", "items", "modelValue", "onUpdate:modelValue", "error-messages"]))
                          : (column.type === 'multiSelect')
                            ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                                _createElementVNode("div", _hoisted_13, _toDisplayString(column.name), 1),
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(column.choises, (name, key) => {
                                  return (_openBlock(), _createBlock(_component_v_checkbox, {
                                    modelValue: values[column.id],
                                    "onUpdate:modelValue": ($event: any) => ((values[column.id]) = $event),
                                    label: name,
                                    value: key,
                                    "hide-details": ""
                                  }, null, 8, ["modelValue", "onUpdate:modelValue", "label", "value"]))
                                }), 256))
                              ]))
                            : (column.type === 'multilineText')
                              ? (_openBlock(), _createBlock(_component_v_textarea, {
                                  key: 3,
                                  modelValue: values[column.id],
                                  "onUpdate:modelValue": ($event: any) => ((values[column.id]) = $event),
                                  class: "mt-n2",
                                  rows: "1",
                                  variant: "outlined",
                                  label: column.name,
                                  color: "primary",
                                  "auto-grow": "",
                                  "error-messages": _unref(errors)[column.id]
                                }, null, 8, ["modelValue", "onUpdate:modelValue", "label", "error-messages"]))
                              : (_openBlock(), _createBlock(_component_v_text_field, {
                                  key: 4,
                                  modelValue: values[column.id],
                                  "onUpdate:modelValue": ($event: any) => ((values[column.id]) = $event),
                                  variant: "outlined",
                                  label: column.name,
                                  "error-messages": _unref(errors)[column.id]
                                }, null, 8, ["modelValue", "onUpdate:modelValue", "label", "error-messages"]))
                    ]))
                  }), 256))
                ]),
                _: 2
              }, 1032, ["value"]))
            }), 256))
          ]),
          _: 1
        }, 8, ["modelValue"])),
    (status.value === 'loaded')
      ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
          _createVNode(_component_v_btn, {
            color: "primary",
            onClick: stepBack,
            variant: "tonal",
            class: "mr-2"
          }, {
            default: _withCtx(() => [
              (step.value === 1)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createTextVNode("Отменить")
                  ], 64))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _createTextVNode("Назад")
                  ], 64))
            ]),
            _: 1
          }),
          (step.value === 3)
            ? (_openBlock(), _createBlock(_component_v_btn, {
                key: 0,
                color: "primary",
                disabled: pending.value,
                onClick: submit
              }, {
                default: _withCtx(() => [
                  _createTextVNode("Отправить отчет")
                ]),
                _: 1
              }, 8, ["disabled"]))
            : (_openBlock(), _createBlock(_component_v_btn, {
                key: 1,
                color: "primary",
                onClick: stepForward
              }, {
                default: _withCtx(() => [
                  _createTextVNode("Далее")
                ]),
                _: 1
              }))
        ]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})